import Highcharts from 'highcharts';

export const figure52 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '1000px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#bf9000', '#ffd966'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
      categories: [ "العالم", "", "الدول الجزرية الصغيرة النامية (SIDS)", "البلدان النامية غير الساحلية (LLDCs)", "أقل البلدان نموًا (LDCs)", "", "أفريقيا جنوب الصحراء", "أوقيانوسيا (باستثناء أستراليا ونيوزيلندا)", "غربي آسيا وشمال أفريقيا", "أمريكا اللاتينية ومنطقة البحر الكاريبي", "أمريكا الشمالية وأوروبا الغربية", "شرق آسيا وجنوب شرق آسيا", "آسيا الوسطى وجنوب آسيا", "أستراليا ونيوزيلندا" ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        }
      },
    }],
    yAxis: [{
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 30,
      min: 0,
      tickInterval: 5,
      gridLineWidth: 2,
      title: {
        text: null,
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [{
      name: '2016',
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [ 13.0, null, 16.3, 14.1, 18.0, null, 20.5, 13.6, 13.1, 12.2, 9.2, 15.0, 13.8, 12.9 ],
    },
    {
      name: '2021',
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [ 13.2, null, 19.0, 14.2, 12.4, null, 20.0, 14.8, 14.2, 14.5, 9.2, 14.5, 12.6, 13.9 ]
    }
  ]
}